import React from "react";
import './styles.css';



  


function Navhov(){

    return (
        <>
            <li>
                <span className="link">
                    <span className="word">
                        <span className="char" data-char="h" style={{"--charIndex": 0 }}>h</span>
                        <span className="char" data-char="o" style={{"--charIndex": 1 }}>o</span>
                        <span className="char" data-char="m" style={{"--charIndex": 2 }}>m</span>
                        <span className="char" data-char="e" style={{"--charIndex": 3 }}>e</span>
                    </span>
                </span>
                    
            </li>
        </>
        
    )
}

export default Navhov;